import * as cardsApi from '@/network/api/cards/cards.api.js'

/** requests
@payload {Object}
@return {promise}
*/
export const validateCard = async (context, payload) => {
    const res = await cardsApi.validateCardPan(payload)
    return res
}

/** Activate Card
@return { promise } Activate Card response
*/
export const cardActivation = async (context, payload) => {
    const res = await cardsApi.activateCard(payload)
    return res
}
